import { Values, Wrapper } from './styles'

export function Roster({
  config,
  typeOfMarker = 'disc',
  marginTop = '16px',
  maxWidth = '546',
  hexagonMarker,
}) {
  return (
    <Wrapper
      hexagonMarker={hexagonMarker}
      typeOfMarker={typeOfMarker}
      className="list"
    >
      {config.map((values, index) => (
        <Values
          maxWidth={maxWidth}
          marginTop={marginTop}
          className="value"
          key={index}
        >
          {values}
        </Values>
      ))}
    </Wrapper>
  )
}
